/**
 * Stock.jsx — Aba "Estoque" do DetailPanel.
 *
 * Conteúdo:
 *   - 3 mini-KPIs (Bling total / ML disponível / ML não disponível).
 *   - StockBreakdownPanel (componente compartilhado com /stock): cards
 *     verde Bling (por depósito) + amarelo ML (full / mercado envios /
 *     direcionado / etc).
 */
import StockBreakdownPanel from '../../../../../components/bling-stock/StockBreakdownPanel';
import { TKPI } from '../../primitives';
import { useDetailPanel } from '../index.jsx';

export function Stock() {
    const { row, tab, warehouseNameById } = useDetailPanel();
    if (tab !== 'estoque') return null;

    // Adapter para o StockBreakdownPanel (compartilhado com /stock).
    const warehousesForPanel = (row.depots || []).map((d) => ({
        id: d.id,
        reference_id: String(d.id),
        name: d.name,
        descricao: d.name,
        quantity: Number(d.qty || 0),
    }));
    const mlStockData = row.mercadolivre
        ? {
              inventory_id: row.mercadolivre.inventory_id || '-',
              total: Number(row.mercadolivre.total || 0),
              available_quantity: Number(row.mercadolivre.available_quantity || 0),
              not_available_quantity: Number(row.mercadolivre.not_available_quantity || 0),
              not_available_detail: Array.isArray(row.mercadolivre.not_available_detail)
                  ? row.mercadolivre.not_available_detail
                  : [],
          }
        : null;

    return (
        <div>
            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr 1fr',
                    gap: 8,
                    marginBottom: 16,
                }}
            >
                <TKPI label="Bling total" value={row.bling || 0} mini />
                <TKPI
                    label="Mercado Livre disponível"
                    value={row.mlAvail || 0}
                    mini
                    color={(row.mlAvail || 0) === 0 ? 'warn' : undefined}
                />
                <TKPI
                    label="Mercado Livre não disponível"
                    value={row.mlUnavail || 0}
                    mini
                    color={(row.mlUnavail || 0) > 0 ? 'warn' : undefined}
                />
            </div>

            {/* Componente compartilhado com /stock — cards verde Bling / amarelo ML */}
            <StockBreakdownPanel
                warehouses={warehousesForPanel}
                warehouseNameById={warehouseNameById || new Map()}
                mlStockData={mlStockData}
                loading={false}
            />
        </div>
    );
}
